import { Injectable } from 'angular-ts-decorators';

import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { PartialSettingsModel } from '@classes/settings-model';

/**
 * Service that expose the Epson fiscal printer interface.
 */
@Injectable('epsonFiscalPrinter')
export class EpsonFiscalPrinter {
  constructor(
    private $log: ng.ILogService,
    private $http: ng.IHttpService,
    private settingsManager: SettingsManager,
  ) {
    'ngInject';
  }

  /**
   * Prints using Epson fiscal printer
   * @param body
   * Content in XML that is supposed to be printed.
   * @param settings
   * Options param to overrides user's settings
   * @return
   * Resolve with http response promise on successfully print attempt, reject otherwise.
   */
  print(body: string, settings?: PartialSettingsModel): ng.IHttpPromise<any> {
    const hostName = (settings ? settings : this.settingsManager.settings)
      .fiscalPrinter?.hostName;

    return this.$http.post(
      `https://${hostName}/cgi-bin/fpmate.cgi?timeout=10000`,
      body,
      {
        headers: { 'Content-Type': 'text/xml; charset=utf-8' },
      },
    );
  }
}
